<template>
  <div class="product">
    <ul class="product-fullpage-indicator">
      <li
        v-for="(item, index) in products"
        :key="item.id"
        class="product-fullpage-indicator-item"
        :class="{ active: activeIndex === index }"
        @click="activeIndex = index"
      >
        <img :src="item.logo" alt />
      </li>
    </ul>
    <transition :duration="duration" :name="transitionName">
      <!-- ... the buttons ... -->
      <div
        :key="activeIndex"
        class="view-wrapper"
        v-if="!loading"
        :style="`backgroundImage:url(${item.cover})`"
      >
        <div class="content">
          <div class="logo">
            <img :src="item.logo" height="100%" alt />
          </div>
          <h2>{{ item.title }}</h2>
          <div class="description">{{ item.description }}</div>
          <div class="subDescription">{{ item.subDescription }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "product",
  data() {
    return {
      products: [],
      activeIndex: 0,
      transitionName: "product",
      scrolling: false,
      duration: 1000,
      loading: false,
    };
  },
  watch: {
    activeIndex(newIndex, oldIndex) {
      if (this.scrolling) {
        return;
      }
      if (this.$route.params.id) {
        delete this.$route.params.id;
        return;
      }

      this.transitionName = newIndex < oldIndex ? "move-down" : "move-up";
    },
  },
  created() {
    this.products = [
      {
        id: "1",
        logo: require("@/assets/image/exr.png"),
        cover: require("@/assets/image/pexels-pavel-danilyuk-7120871.jpg"),
        description: "EXR",
        subDescription: `早在2001年，EXR打破人类传统固有思维模式中，将运动服装与休闲服装相区分开的观念，通过不断地试验及研究，率先成功在亚洲潮流风向之都的韩国，推出全新的服饰着装理念--个性运动休闲服饰，掀起现代都市人群着装最为时尚的个性运动风暴。

EXR 作为这种新型服饰领域中最杰出的代表，不断将其创新及发展，始终秉承进取精神，给顾客以最精彩地服饰穿着享受，并将这种服饰流行趋势演化成都市文明表象及社会文化潮流的新型生活方式，推广至全世界各个地区……

成立于2001年的EXR，构筑全球范围设计体系，在英国伦敦、韩国首尔、日本东京以及中国上海均设有设计工作室。`,
        link: "15757183400",
      },
      {
        id: "2",
        logo: require("@/assets/image/amilss.png"),
        cover: require("@/assets/image/pexels-burst-374897.jpg"),
        description: "爱美斯",
        subDescription: `杭州麦伦时装有限公司，位于杭州市江干科技经济园内，是一家全类品牌运营综合型公司，公司下设科类齐全，运作明确的管理部门。依托现代化的经营管理理念，采用“五化”管理标准。以“努力让顾客满意”为宗旨，以“做稳、做强、做精，构筑一流企业”目标。公司曾多次参加北京、俄罗斯、广州等国内外专业服装博览会，多次被评为“中国著名品牌”“央视上榜品牌”“杭州十佳女装品牌”等荣誉。
公司现有“AIMISS爱美斯”专业羽绒服品牌，其中包括“Aimiss adult”“Aimiss kids”两大分类。“Aimissdult”着力服务于25-45岁的都市新潮女性，她们穿行与工作、社交及休闲不同场合，给消费者带来的是个性的体验，美丽的表现及高雅时尚的品味。体现“畅想、时尚、真我”的生活方式。“Aimiss kids”产品风格是以时尚、休闲为大方向，服务于3-16岁快乐小孩。以“从简单、不平凡中挖掘每一位小朋友独特的气质与内涵”为核心理念。简洁、明快、时尚的感觉惯穿了每件作品。彰显自我个性。`,
      },
      {
        id: "3",
        logo: require("@/assets/image/sansuo.png"),
        cover: require("@/assets/image/pexels-cup-of-couple-7303151.jpg"),
        description: "三所",
        subDescription: `目前全球化营销战略已全面进驻韩国、中国、日本、印度尼西亚等国家，凭借精准的市场定位以及独特的服饰设计，在中国的业绩以每年100%以上的速度迅猛增长，目前在全球范围内卖店已达到300余家，国内一二级重点城市中的高档百货中也已设立了100余家卖店。

EXR将以不断超越和创新为理念，以“打造全球最流行、最具奢华和强烈动感的个性运动休闲服饰”为企业目标，力求为中国市场带来更多的先锋时尚设计理念和时尚产品

独享个性与时尚的激情碰撞！尽在无限进取中的EXR……`,
      },
      {
        id: "4",
        logo: require("@/assets/image/shier.png"),
        cover: require("@/assets/image/pexels-fauxels-3183198.jpg"),
        description: "拾尔光年",
        subDescription:
          "从长远愿景来看，十二光年希望能够变成一个行业代名词，成为一个产业品牌。通过搭建平台和渠道，让更多有价值的文化创意故事和设计能够变成消费产品进入大家的日常，推动整个Z世代生活方式的零售形态发展。",
      },
    ];
  },
  mounted() {
    window.addEventListener("mousewheel", this.mousewheelHandler);
  },
  destroyed() {
    window.removeEventListener("mousewheel", this.mousewheelHandler);
  },
  computed: {
    item() {
      return this.products[this.activeIndex] || {};
    },
  },
  methods: {
    mousewheelHandler(e) {
      if (this.scrolling) {
        return;
      }
      this.scrolling = true;
      if (e.wheelDelta > 0) {
        this.transitionName = "move-down";
        this.activeIndex =
          this.activeIndex === 0
            ? this.products.length - 1
            : this.activeIndex - 1;
      } else {
        this.transitionName = "move-up";
        this.activeIndex = (this.activeIndex + 1) % this.products.length;
      }
      setTimeout(() => {
        this.scrolling = false;
      }, this.duration);
    },
  },
};
</script>
<style lang="less" scoped>
.move-up-leave-active,
.move-up-enter-active,
.move-down-leave-active,
.move-down-enter-active {
  transition: all 0.7s;
  transition-timing-function: cubic-bezier(0.66, 0, 0.34, 1);
}
.move-up-leave-to,
.move-up-enter,
.move-down-leave-to,
.move-down-enter {
  opacity: 0;
}

.move-up-leave-to,
.move-down-enter {
  transform: translateY(-100%);
}
.move-down-leave-to,
.move-up-enter {
  transform: translateY(100%);
}

.product {
  position: fixed;
  z-index: -1;
  top: 60px;
  right: 0;
  left: 0;
  bottom: 0;
  min-height: 500px;
  min-width: 700px;
  background: rgba(232, 233, 235, 0.151);
  &-fullpage-indicator {
    position: absolute;
    z-index: 333;
    left: 50px;
    top: 50%;
    transform: translateY(-50%);

    &-item {
      margin: 22px 0;
      width: 5vh;
      height: 5vh;
      min-height: 30px;
      min-width: 30px;
      cursor: pointer;
      transition: all 0.3s;
      border-radius: 50%;
      overflow: hidden;

      &:hover,
      &.active {
        transform: scale(1.3);

        box-shadow: 0 0 14px 0 @box-shadow-dark-color;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .view-wrapper {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: absolute;
    height: 100vh;
    width: 100%;
    // padding-top: 100px;
    padding-left: 100px;

    .content {
      width: 500px;
      transform: translateY(-50%);
      position: absolute;
      top: 50%;
      right: 0;
      margin-right: 50px;
      // text-align: center;
      .logo {
        width: 80px;
        height: 80px;
      }
      h2 {
        margin: 30px 0;
      }
      .description {
        text-align: right;
        font-weight: bold;
        font-size: 40px;
        color: #32418d;
      }
      .subDescription {
        margin-top: 10px;
        text-indent: 25px;
        color: #3d3b3b;
        line-height: 1.4;
      }
      .link {
        margin-top: 40px;
        span {
          color: @main-color;
        }
      }
    }
  }
}
</style>
